module.exports = __webpack_public_path__ + "static/media/MuseoSansLight.e8adc412.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansLight/MuseoSansLight.eot
// module id = 246
// module chunks = 0